<template>
   <main class="programma">
      <section>
         <div class="container pt-2 pb-4">
            <div class="category-top d-print-none">
               <div class="category font-weight-semibold text-uppercase">{{area}}</div>
            </div>            
            <div class="row justify-content-between">
               <intro>
                  <template v-slot:title v-if="post">{{post.titolo}}</template>
                  <template v-slot:intro v-if="post"><vue-markdown>{{post.corpo}}</vue-markdown></template>
               </intro>
               <div class="col-12 col-md-4 mt-3">
                  <shareArea :url="this.$route.fullPath"></shareArea>
                  <miniMenu v-if="post && post.maggioriInfo.length > 0" :minimenu="post.maggioriInfo" :area="post.slug" :slug="post.slug"></miniMenu>
                  <!-- newsletter></newsletter -->
               </div>
            </div>
         </div>
      </section>

      <section class="section section-inset-shadow pb-0 pt-2 pb-5">
         <div id="content" class="container pt-2 pb-4 px-0 px-md-3 pt-5">
            <div class="row">
               <!-- Call cards -->                              
               <card-area v-for="(item) in subCategoryPosts" :key="`${item.id}`" :title="item.titolo" :data="item" :area="item.area" :id="`${item.id}`" :noFooter="true">
                  <template v-slot:header>{{item.titolo}}</template>
                  {{item.breve}}
               </card-area>
            </div>
         </div>
      </section>


      <section class="section pb-0 pt-0 pb-5">
         <div id="area-specializzazione" class="container pt-2 pb-4 px-0 px-md-3 pt-3">
            <h3>Aree di Specializzazione</h3>
            <!-- Call cards -->                              
            <div class="row" v-if="specializzazionePosts">
               <imgcard v-for="(notizia) in specializzazionePosts" :key="notizia.id" :id="notizia.idContenuto" :articolo="notizia" :area="'aree-specializzazione'"/>
            </div>
         </div>
      </section>
   </main>
</template>
<script>
import { getPage, getAssociatedPostsIDs, getAssociatedPosts  } from './../service';
import intro from "@/components/Intro";
import shareArea from "@/components/ShareArea";
import cardArea from "@/components/CardArea";
import miniMenu from "@/components/MiniMenu";
import imgcard from "@/components/ImgCard";
//import newsletter from "@/components/Newsletter";
import VueMarkdown from 'vue-markdown';


export default {
   name: "categoryPosts",   
   components: {
      VueMarkdown,
      intro,
      shareArea,
      cardArea,
      miniMenu,
      imgcard
      //newsletter,
   },
   title() {
      let pageTitle = this.$route.params.title; 
      return pageTitle;
   },
   data() {
      return {
         post: null,
         subCategoryPosts: null,
         specializzazionePosts: null,
         area: null
      }         
   },   
   methods: {
      loadPost: async function(id, area) {
         this.post = undefined;
         try {                     
            const result = await getPage(id, area);
            //this.post = this.parseArticle(result);
            this.post = result;

            if(result.linkList !== null){
               this.loadSubCategoryPosts(result.linkList);
            }
            this.loadAssociatedPosts(this.post.id);
         } catch (ex) {
            console.log('failed loadPost');
            this.post = null;
         } 
      },

      loadSubCategoryPosts: async function(idArr){
         try {
            let posts = await getAssociatedPostsIDs(idArr);
            this.subCategoryPosts = posts.posts;
         } catch (ex) {
            console.log('failed loadSubcategories');
            this.subCategoryPosts = null;
         }
      },

      loadAssociatedPosts: async function(id){
         try {
            let posts = await getAssociatedPosts(id, 'aree-specializzazione');
            this.specializzazionePosts = posts.posts;
         } catch (ex) {
            console.log('failed loadSubcategories');
            this.specializzazionePosts = null;
         }
      },      

     /* parseArticle: function(response){
         return {
            id:            response.id,
            modified:      response.lastModified,
            titolo:        response.data.titolo.iv,
            breve:         response.data.breve.iv,
            corpo:         response.data.corpo.iv,
            maggioriInfo:  response.data.maggioriInformazioni.iv, 
            slug:          response.data.slug.iv
         }
      },*/
   },   
   created(){      
      this.area = (this.$route.params.id === undefined ? this.$route.meta.parent : this.$route.params.area);
      this.loadPost(this.$route.params.slug, this.area);
   },

   watch: {
      $route: {
         handler: function(to) {
            this.loadPost(to.params.id);
         }
      }
   },
   
};
</script>
